module.exports = __webpack_public_path__ + "static/sheepblanket-96a34d00d03e8c7662820c340ad78180.jpeg";